<template>
  <div class="app-container">
    <el-tabs v-model="tabName" @tab-click="onTabClick" type="card">
      <el-tab-pane label="营销设置" name="market"></el-tab-pane>
      <el-tab-pane label="销售设置" name="sale"></el-tab-pane>
      <el-tab-pane label="采购设置" name="purchase"></el-tab-pane>
      <el-tab-pane label="库存设置" name="stock"></el-tab-pane>
      <el-tab-pane label="资金设置" name="capital"></el-tab-pane>
      <el-tab-pane label="通用设置" name="common"></el-tab-pane>
    </el-tabs>
    <market v-if="tabName=='market'" ref="market" />
    <sale v-if="tabName=='sale'" ref="sale" />
    <purchase v-if="tabName=='purchase'" ref="purchase" />
    <stock v-if="tabName=='stock'" ref="stock" />
    <capital v-if="tabName=='capital'" ref="capital" />
    <common v-if="tabName=='common'" ref="common" />
  </div>
</template>
<script>
import market from "@/components/sys/basic/opt/market";
import sale from "@/components/sys/basic/opt/sale";
import purchase from "@/components/sys/basic/opt/purchase";
import stock from "@/components/sys/basic/opt/stock";
import capital from "@/components/sys/basic/opt/capital";
import common from "@/components/sys/basic/opt/common";

export default {
  name: "opt",
  components: {
    market,
    sale,
    purchase,
    stock,
    capital,
    common,
  },
  data() {
    return {
      tabName: "common",
    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.$nextTick(() => {
        this.$refs[this.tabName].getData();
      });
    },
    onTabClick() {
      this.reload();
    },
  },
};
</script>